import { Box, Stack, styled } from '@mui/material';

export const TimeWrapper = styled(Stack)({
  justifyContent: 'center',
  alignItems: 'center',
  height: 32,
  width: 32,
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '14px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
});

export const ChartCardContainer = styled(Box, { shouldForwardProp: (prop) => prop !== 'small' })<{
  small?: boolean;
}>(({ small }) => {
  return {
    position: 'relative',
    backgroundColor: '#191D26',
    borderRadius: '8px',
    padding: small ? '16px' : '20px',
  };
});

export const ComingSoonBlur = styled(Box)({
  position: 'absolute',
  inset: 0,
  zIndex: 2,
  backdropFilter: 'blur(6px)',
  background:
    'linear-gradient(90deg, rgba(9,9,13,0.7) 0%, rgba(9,9,13,0.6) 20%, rgba(9,9,13,0.4) 40%, rgba(9,9,13,0.4) 60%, rgba(9,9,13,0.6) 80%, rgba(9,9,13,0.7) 100%)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#fff',
  textAlign: 'center',
  borderRadius: '8px',
});
